import type { ReactNode } from "react";

import { Label } from "@/components/ui/Input";
import { HoverHintWithGlyph } from "@/components/ui/title-help";

export function PurchaseOrderHeaderFieldLabel({
  label,
  hoverHint,
  embedded = false,
  trailing,
}: {
  label: string;
  hoverHint?: string;
  /** When nested inside another field label row, omit outer margin. */
  embedded?: boolean;
  trailing?: ReactNode;
}): JSX.Element {
  const content = (
    <>
      <Label className="mb-0">{label}</Label>
      {hoverHint ? <HoverHintWithGlyph hoverHint={hoverHint} /> : null}
    </>
  );
  if (embedded) {
    return (
      <div className="flex min-w-0 flex-1 items-center gap-1">
        {content}
        {trailing}
      </div>
    );
  }
  return (
    <div className="mb-1.5 flex min-h-5 items-center gap-1">
      {content}
      {trailing}
    </div>
  );
}
